import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ActivityLogMaintenanceCont from "presentation/view/container/ActivityLog/ActivityLogContMain";

CommonEntrypoint(<ActivityLogMaintenanceCont/>)